
export default {
    name: 'rapport-coupon',
    components: {},
    props: {
        rapport_coupons: Array,
        by_prestation: String,
        modal_toggler: Number
    },
    data () {
        return {
            fields: [
                { key: 'no', label: 'N°' },
                { key: 'ref', label: 'Référence' }, "date", { key: 'user', label: 'Caissier(e)' },
                { key: 'libelle', label: 'Libellé' }, "patient",  { key: 'montant', label: 'Montant' }
            ],
           
            filter: "",
            perPage: -1,
            print_per_page: -1,
            currentPage: 1,
            coupon_len: 0,
        }
    },

    watch: {
        modal_toggler() {
            this.refreshCoupon()
            this.filter = this.by_prestation
        }
    },

    computed: {

    },

    mounted () {

    },

    methods: {
        refreshCoupon() {
            if (this.rapport_coupons) {
                this.coupon_len = this.rapport_coupons.length
            }
        }
    }
}